import { TranslateLoader } from "@ngx-translate/core";

import { HttpClient } from "@angular/common/http";
import { from, map, Observable, switchMap } from "rxjs";
import { PartnerService } from "./partner.service";

export class CustomLoader implements TranslateLoader {
  private basePath: string = "/assets/i18n";
  constructor(
    private http: HttpClient,
    private partnerService: PartnerService
  ) {}

  getTranslation(langCountry: string): Observable<any> {
    return from(this.partnerService.getPartnerCode()).pipe(
      switchMap((partnerCode) => {
        const selected = this.partnerService.partnerList.find(
          (x) => x.code === partnerCode
        );

        if (selected?.takaful) {
          // ✅ If takaful partner, merge parent + child translation files
          return this.http
            .get(`${this.basePath}/${langCountry}.json`)
            .pipe(
              switchMap((parent) =>
                this.http
                  .get(`${this.basePath}/${langCountry}-takaful.json`)
                  .pipe(map((child) => Object.assign({}, parent, child)))
              )
            );
        }

        // ✅ Default case
        return this.http.get(`${this.basePath}/${langCountry}.json`);
      })
    );
  }
}
